<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { home, pricing, workflow } from '@/routes';

const currentYear = new Date().getFullYear();

const footerLinks = {
    produit: [
        { label: 'Fonctionnalités', href: '/#features' },
        { label: 'Workflow', href: workflow.url() },
        { label: 'Tarifs', href: pricing.url() },
        { label: 'FAQ', href: '/#faq' },
    ],
    legal: [
        { label: 'CGU', href: '#' },
        { label: 'Confidentialité', href: '#' },
        { label: 'CGV', href: '#' },
    ],
};
</script>

<template>
    <footer class="border-t border-border/40 py-12">
        <div class="mx-auto max-w-5xl px-4">
            <div
                class="flex flex-col gap-10 md:flex-row md:items-start md:justify-between"
            >
                <div class="max-w-xs">
                    <Link :href="home()" class="mb-4 flex items-center gap-2">
                        <div
                            class="flex h-7 w-7 items-center justify-center rounded-lg bg-brand text-[10px] font-semibold text-white"
                        >
                            R
                        </div>
                        <span class="text-sm font-semibold text-foreground"
                            >Rewio</span
                        >
                    </Link>
                    <p class="text-sm leading-relaxed text-muted-foreground">
                        L'espace de travail pour votre revue de littérature. De
                        l'import à la rédaction, sans jongler entre vos outils.
                    </p>
                </div>

                <div class="flex gap-16">
                    <div>
                        <h3
                            class="mb-4 text-xs font-medium tracking-wider text-foreground uppercase"
                        >
                            Produit
                        </h3>
                        <ul class="space-y-2.5">
                            <li
                                v-for="link in footerLinks.produit"
                                :key="link.label"
                            >
                                <Link
                                    v-if="!link.href.startsWith('#')"
                                    :href="link.href"
                                    class="text-sm text-muted-foreground transition-colors hover:text-foreground"
                                >
                                    {{ link.label }}
                                </Link>
                                <a
                                    v-else
                                    :href="link.href"
                                    class="text-sm text-muted-foreground transition-colors hover:text-foreground"
                                >
                                    {{ link.label }}
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3
                            class="mb-4 text-xs font-medium tracking-wider text-foreground uppercase"
                        >
                            Légal
                        </h3>
                        <ul class="space-y-2.5">
                            <li
                                v-for="link in footerLinks.legal"
                                :key="link.label"
                            >
                                <a
                                    :href="link.href"
                                    class="text-sm text-muted-foreground transition-colors hover:text-foreground"
                                >
                                    {{ link.label }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="mt-10 border-t border-border/40 pt-6">
                <p class="text-center text-xs text-muted-foreground">
                    © {{ currentYear }} Rewio. Tous droits réservés.
                </p>
            </div>
        </div>
    </footer>
</template>
